const firstValue = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const notificationTypeLabel = (type) => {
  if (type === "online_booking") return "Online booking";
  if (type === "message") return "Message";
  if (type === "waitlist_offer") return "Waitlist offer";
  if (type === "waitlist_slot_opened") return "Waitlist slot opened";
  return type ? String(type).replace(/[_-]+/g, " ") : "Notification";
};

const fallbackClient = (client, clientId, type) => {
  const firstName = firstValue(client.first_name);
  const lastName = firstValue(client.last_name);
  if (firstName || lastName) return { ...client };
  if (clientId !== undefined && clientId !== null && clientId !== "") {
    return { ...client, first_name: "Client", last_name: `#${clientId}` };
  }
  return { ...client, first_name: notificationTypeLabel(type), last_name: "" };
};

export const normalizeNotificationResponse = (response) => {
  if (Array.isArray(response)) return { data: response };
  if (response && typeof response === "object" && Array.isArray(response.data)) return response;
  return { data: [] };
};

export const notificationRows = (response) => normalizeNotificationResponse(response).data;

export const canOpenNotificationAppointment = (notification = {}) => (
  notification !== null
  && notification.isAppointmentNotification === true
  && notification.appointmentId !== undefined
  && notification.appointmentId !== null
  && notification.appointmentId !== ""
);

export const toNotificationViewModel = (row = {}) => {
  const type = row.type;
  const appointment = row.appointment || {};
  const isWaitlistNotification = String(type || "").startsWith("waitlist_");
  const waitlist = isWaitlistNotification ? row.waitlist || {} : {};
  const appointmentClient = appointment.client || {};
  const appointmentSale = appointment.sale || {};
  const clientChat = row.clientchat || {};
  const chatClient = waitlist.client || clientChat.client || {};
  const appointmentId = firstValue(row.appointment_id, appointment.id, "");
  const clientId = firstValue(row.client_id, appointmentClient.id, chatClient.id, "");
  const appointmentClientView = fallbackClient(appointmentClient, clientId, type);
  const messageClientView = fallbackClient(chatClient, clientId, type);
  const typeLabel = notificationTypeLabel(type);
  const staff = waitlist.staff || appointment.staff || {};
  const staffDisplayName = [staff.first_name, staff.last_name].filter(Boolean).join(" ");
  const clientDisplayName = [appointmentClientView.first_name, appointmentClientView.last_name].filter(Boolean).join(" ");
  const messageClientDisplayName = [messageClientView.first_name, messageClientView.last_name].filter(Boolean).join(" ");

  return {
    ...row,
    actionId: row.id,
    notificationId: row.id,
    appointmentId,
    clientChatId: firstValue(row.client_chat_id, clientChat.id, ""),
    clientId,
    appointment: { ...appointment, client: appointmentClientView },
    invoiceNumber: String(firstValue(appointmentSale.invoice_number, appointmentSale.invoiceNumber, "")).replace(/^#/, ""),
    client: appointmentClientView,
    clientchat: { ...clientChat, client: messageClientView },
    messageClient: messageClientView,
    clientDisplayName,
    messageClientDisplayName,
    messageText: clientChat.message || typeLabel,
    isWaitlistNotification,
    serviceName: waitlist.service?.name || (appointment.service && appointment.service.name
      ? appointment.service.name
      : typeLabel),
    staffDisplayName,
    isAppointmentNotification: Boolean(appointmentId) && type !== "message" && !isWaitlistNotification,
    typeLabel,
    appointmentEventLabel: type !== "online_booking" ? ""
      : row.event_type === "appointment_booked" ? "Appointment booked"
        : row.event_type === "appointment_cancelled" ? "Appointment cancelled"
          : "Appointment notification",
  };
};
